module.exports = __webpack_public_path__ + "static/img/yagi_04.55039ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yagi_04.jpg
// module id = BxoS
// module chunks = 0